import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageProvider";
import "./CookieConsent.sass";

const COOKIE_CONSENT_KEY = "cookie_consent";

function CookieConsent() {
    const [visible, setVisible] = useState(false);
    const { t, localizedPath } = useTranslation();

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
        setVisible(false);
        // Enable Google AdSense / Analytics cookies
        window.gtag?.("consent", "update", {
            ad_storage: "granted",
            analytics_storage: "granted",
            ad_user_data: "granted",
            ad_personalization: "granted",
        });
    };

    const handleReject = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, "rejected");
        setVisible(false);
        // Disable Google AdSense / Analytics cookies
        window.gtag?.("consent", "update", {
            ad_storage: "denied",
            analytics_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
        });
    };

    if (!visible) return null;

    return (
        <div className="cookie-consent" role="dialog" aria-label="Cookie consent">
            <div className="cookie-consent__content">
                <div className="cookie-consent__text">
                    <h3>{t("cookie.title")}</h3>
                    <p>
                        {t("cookie.text")} <Link to={localizedPath("/politica-de-confidentialitate")}>{t("cookie.privacy")}</Link>.
                    </p>
                </div>
                <div className="cookie-consent__actions">
                    <button className="cookie-consent__btn cookie-consent__btn--reject" onClick={handleReject}>
                        {t("cookie.reject")}
                    </button>
                    <button className="cookie-consent__btn cookie-consent__btn--accept" onClick={handleAccept}>
                        {t("cookie.accept")}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieConsent;
